import React from 'react';
//import styles from './content.module.css';
//import PageLink from '../../../PageLink/PageLink.js';
//import basfLogo from './basflogo.svg';

const Content=(props)=>{
	return <React.Fragment/>;

	/*
	let image_background=null;
	if(props.data.Metadata.header_banner)
		image_background=<img alt="" className={props.content_styles.feature} src={window.global.content_hub.ASSETS+'/images/'+props.data.Metadata.header_banner+'?resize=1&width='+(props.data.feature===true?'750':'525')}/>;
	return (
		<div className={props.content_styles.container}>
			<div className={styles.header} style={{backgroundColor:props.primary_tag.Colour}}><img alt="" src={basfLogo}></img></div>
			<div className={props.content_styles.header} onClick={props.open}>
				{image_background}
			</div>
			<div className={props.content_styles.details}>
				<div>
					<p><label className={styles.label}>Crop: </label><span>{props.data.Metadata.crop}</span></p>
					</div>
					<div>
						<p><label className={styles.label}>When to apply: </label><span>{props.data.Metadata.when_to_apply}</span></p>
					</div>
					<div>
						<p><label className={styles.label}>Did you know: </label><span>{props.data.Metadata.did_you_know}</span></p>
					</div>
				</div>
				<PageLink open={props.open} label="Know more"/>
		</div>
	);
	*/
}

export default Content;